import { CancelSaleTaskAccept } from '@/api/my'
import { NotFindKeyFeedback, KeyRelationTimeGet } from '@/api/detailPage'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      orderInfo: null, // 订单信息
      isShowCancelOrderPopup: false, // 是否展示取消订单弹窗
      isExceeds120Second: false, // 是否超过120s
      diffSeconds: '', // 服务器-关联时间差
      countInterval: null, // 关联时间倒计时对象
      isSwappableKeyword: false, // 是否可切换关键词
      isWaitingSearch: true, // 是否是待搜索状态
      oldRouterName: '', // 上一个路由名称
      backRoutersList: ['goodsDetail'] // 返回一个路由的白名单
    }
  },
  computed: {
    ...mapGetters(['accurateMode', 'configAccurateMode']),
    // 是否展示切换关键词按钮
    isShowChangeKeyWordBtn() {
      // 在到达120s后，若【是否可切换关键词】为【是】
      return this.isExceeds120Second && this.isSwappableKeyword
    }
  },
  methods: {
    ...mapMutations(['SET_IS_HAVE_UNFINISHED_ORDER']),
    // 超过120s做以下处理
    exceeds120Second() {
      // 在到达120s后，若【是否可切换关键词】为【是】，在用户选中该选项时，在选项下方展现【更换关键词】
      this.isExceeds120Second = true
    },
    // 服务器-关联时间差
    getServiceTime() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.endTiming()
      let params = {
        productID: this.orderInfo.ProductID,
        keywordId: this.orderInfo.KeywordID
      }
      // 服务器-关联时间差
      return KeyRelationTimeGet(params)
        .then((res) => {
          Indicator.close()
          // 当前服务器时间
          let nowTime = parseInt(res.Data.NowTime.replace(/\D+/gi, ''))
          // 关键词的关联时间
          let relationTime = parseInt(res.Data.RelationTime.replace(/\D+/gi, ''))
          // 服务器-关联时间差
          this.diffSeconds = 120 - parseInt((nowTime - relationTime) / 1000)
          if (this.diffSeconds <= 0) {
            // 超过120s做以下处理
            this.exceeds120Second()
          } else {
            // 开启倒计时
            this.isExceeds120Second = false
            this.countInterval = setInterval(this.countDown, 1000)
          }
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    // 首次加载数据,绑定数据
    handelCancelOrder(orderInfo) {
      this.orderInfo = orderInfo
      if (this.orderInfo.TaskID) {
        this.orderInfo = {
          ...this.orderInfo,
          TaskId: this.orderInfo.TaskID
        }
      }
      // 是否是待搜索状态
      this.isWaitingSearch = this.orderInfo.SOStatus === 4
      // 是否可切换关键词
      this.isSwappableKeyword = orderInfo.IsSwappableKeyword
    },
    // 关联时间倒计时
    countDown() {
      this.diffSeconds = this.diffSeconds - 1
      if (this.diffSeconds <= 0) {
        this.exceeds120Second()
        clearInterval(this.countInterval)
      }
    },
    // 切换关键词
    changeKeyWord({ success = null, fail = null } = null) {
      this.endTiming()
      this.isShowCancelOrderPopup = false
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let postData = {
        productID: this.orderInfo.ProductID,
        keywordId: this.orderInfo.KeywordID
      }
      NotFindKeyFeedback(postData)
        .then((res) => {
          Indicator.close()
          MessageBox({
            title: '提示',
            message: '已为你更换一个关键词，这次一定很快就找到的！',
            showCancelButton: false,
            confirmButtonText: '我知道了',
            confirmButtonClass: 'c000'
          })
          success(this.orderInfo)
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
            fail()
          }
        })
    },
    // 自定义切换关键词按钮成功和失败失败后的操作
    customChangeKeyWordEvent() {
      this.changeKeyWord({
        success: this.fetchOpenShouhuoData,
        fail: this.fetchOpenShouhuoData
      })
    },
    // 清空定时器
    endTiming() {
      if (this.countInterval) clearInterval(this.countInterval)
    },
    // 确认取消
    cancelSaleTaskAccept({ orderCancelReason = '', success = null, fail = null } = null) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.isShowCancelOrderPopup = false
      this.endTiming()
      let data = {
        taskID: this.orderInfo.TaskId,
        OrderCancelReason: orderCancelReason,
        IsMoreTwoMinutes: this.isExceeds120Second
      }
      CancelSaleTaskAccept(data)
        .then((res) => {
          Indicator.close()
          this.SET_IS_HAVE_UNFINISHED_ORDER(false)
          success(res)
        })
        .catch((err) => {
          Indicator.close()
          fail(err.ErrMsg)
        })
    },
    // 自定义取消订单按钮成功和失败失败后的操作
    customCancelSaleTaskAccept({ orderCancelReason = '' }) {
      this.cancelSaleTaskAccept({
        orderCancelReason: orderCancelReason,
        success: () => {
          console.log(this.backRoutersList)
          console.log(this.oldRouterName)
          if (this.backRoutersList.indexOf(this.oldRouterName) !== -1) {
            this.$router.go(-1)
          } else {
            this.$router.replace({
              name: 'souhuo'
            })
          }
        },
        fail: (errMsg) => {
          if (errMsg === '任务已取消') {
            Toast('任务已取消，无需重复操作，将自动跳转首页')
            setTimeout(() => {
              this.$router.replace({
                name: 'souhuo'
              })
            }, 3000)
          } else {
            Toast(errMsg)
          }
        }
      })
    },
    async cancelOrder() {
      // 判断【关键词精确模式开关配置】状态
      if (!(this.configAccurateMode && this.accurateMode === 1)) {
        // 若为关闭，则按照原有逻辑进行展现【切换关键词】按钮
        await this.getServiceTime()
      }
      this.isShowCancelOrderPopup = true
    },
    // 关闭弹窗
    closeCancelOrderPopup() {
      this.endTiming()
      this.isShowCancelOrderPopup = false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.oldRouterName = from.name
    })
  }
}
